import { Labels } from "@/store/modules/task"
import { LabelId, isOnTheTask, isPatrolDelayed } from "@/store/modules/task"

/**
 * Mixin zawierający wspólną logikę dla kart patroli
 * Używamy mixina zamiast composable dla kompatybilności z Vue 2
 */
export const patrolCardMixin = {
  data() {
    return {
      free: {
        label_id: LabelId.IDLE,
        details: {}
      }
    }
  },

  computed: {
    task() {
      if (this.patrol?.tasks?.length === 0) {
        return null
      }
      for (const task of this.patrol.tasks) {
        if (isOnTheTask(task)) {
          return task
        }
      }
      return this.patrol.tasks[0]
    },

    hasError() {
      return isPatrolDelayed(this.patrol)
    },

    badgeColor() {
      return this.hasError ? 'error' : 'success'
    },

    progress() {
      return this.stats?.progress || 0
    },

    lastLocation() {
      return this.patrol?.gps?.last
    },

    site() {
      return this.task?.event.site
    },

    stats() {
      if (this.patrol?.tasks?.length === 0) {
        return { progress: 0 }
      }
      return this.task?.details?.stats || { progress: 0 }
    },

    status() {
      if (this.patrol?.tasks?.length === 0) {
        return null
      }
      return this.task?.details?.status
    },

    title() {
      return this.$options.filters.userName(this.patrol)
    },

    centered() {
      return false
    }
  },

  methods: {
    statusName() {
      if (!this.task?.details?.status?.label_id) {
        return 'Brak statusu'
      }
      return Labels.get(this.task.details.status.label_id).title
    },

    isSameDay() {
      const task = this.task
      if (!task?.modified_at) {
        return false
      }
      return this.$options.filters.isSameDay(task.modified_at)
    }
  }
}
